import * as c from 'constants/modalPage';

export function closeModalPage(groupID?: string) {
  return {
    type: c.CLOSE_MODAL_PAGE,
    groupID,
  };
}
